import {React, ReactDOM, ReactLite, extend} from 'pexui';
import * as utils from '../../utilities/utils';

/**
 * Show a Comonent in new browser window
 * @param {function} ComponentFactory
 * @param {object} opts 
 *  {
 *    title
 *    stylesheets
 *    javascripts
 *  }
 */
export function showInNewWindow(ComponentFactory, props, opts){
    
    let html = '<!DOCTYPE html>\n'+
        '<html lang="en"><head>\n' +
        '<meta content="width=device-width, initial-scale=1.0, minimum-scale=1.0" name="viewport" id="viewport">\n' +
        '<meta http-equiv="X-UA-Compatible" content="IE=edge">\n';
    if(opts){
        if(opts.title){
            html += '<title>' + opts.title + '</title>\n';
        }
        if(opts.stylesheets && Array.isArray(opts.stylesheets)){
            for(let i=0;i<opts.stylesheets.length;i++){
                html += '<link type="text/css" rel="stylesheet" href="' + opts.stylesheets[i] + '" crossorigin="anonymous">\n';
            }
        }
        if(opts.javascripts && Array.isArray(opts.javascripts)){
            for(let i=0;i<opts.javascripts.length;i++){
                html += '<script type="text/javascript" src="' + opts.javascripts[i] + '"></script>\n';
            }
        }
        // single script tag
        if(opts.script){
            html += '<script type="text/javascript">\n' + opts.script + '</script>\n';
        }
    }

    html += '</head>\n';
    html += '<body style="margin:0"' + (opts.onload? ' onload="' + opts.onload + '"': '') + '>Loading...</body></html>';

    const browserWindow = window.open("", "FAQ", "", true);
    const browserDocument = browserWindow.document;
    browserDocument.write(html);
    
    const showIt = () => {
        if(browserDocument.createElement && browserDocument.body){
            // rendering in the new document instead
            const savedDoc = ReactLite.currentDocument;
            ReactLite.currentDocument = browserDocument;        
            try{
                const comp = React.createElement(ComponentFactory, props);
                comp.parentWindowInstance = browserWindow;
                ReactDOM.render(comp, browserDocument.body);
            }catch(err){
                console.error(err);
            }
            ReactLite.currentDocument = savedDoc;
        }else{
            console.log("New window not ready, try later.");
            setTimeout(showIt, 500);
        }
    }

    showIt();
}



// WEBPACK FOOTER //
// ./application/src/views/comps/win.jsx